import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { ENV_CONFIG } from '@ps/core-config';
import {
  SegmentParentDto,
  SegmentParentUpdatePayloadDto,
  SupplierSegmentationResponseDto,
} from './dtos/supplier-segmentation.dto';
import { SegmentParentMapper } from './mappers/segment-parent.mapper';
import {
  SegmentParent,
  SupplierSegmentation,
} from '../models/segment-parent.model';

@Injectable({ providedIn: 'root' })
export class SupplierSegmentationApi {
  private readonly _httpClient = inject(HttpClient);
  private readonly _environmentConfig = inject(ENV_CONFIG);
  private readonly _baseUrl = `${this._environmentConfig.pureSpectrum.url}/buyers/v3/attributes`;
  private readonly _mapper = new SegmentParentMapper();

  public segmentParents(companyId: number): Observable<SupplierSegmentation> {
    return this._httpClient
      .get<SupplierSegmentationResponseDto>(
        `${this._baseUrl}/supplier-segmentation-list/${companyId}`,
      )
      .pipe(map((response) => this._mapper.fromResponseDto(response)));
  }

  public updateSegmentParent(
    parentId: number,
    payload: SegmentParentUpdatePayloadDto,
  ): Observable<SegmentParent> {
    return this._httpClient
      .patch<SegmentParentDto>(`${this._baseUrl}/${parentId}`, payload)
      .pipe(map((dto) => this._mapper.fromDto(dto)));
  }
}
